import { Table, Radio, Button, message } from 'antd';
// import { Link } from 'react-router-dom'
import React, { useState, useRef } from 'react';
import SlidInActivityDetail from '@/components/slide-in-activity-detail';
import './activityList.less';
// import Dialog from '../../../components/resource-apply-dialog'
import apis from '../../../apis/index';
// import DialogPin from '../../../components/resource-pin-dialog'
// import DialogCms from '@/components/resource-cms-dialog'
import DialogCheck from '@/components/resource-check-dialog';
import { withRouter } from 'react-router-dom';
import { ACTIVITY_LEVELS_MAP, ACTIVITY_STATUS_MAP } from '@/constants/index';

const renderContent = (value, row, index) => {
  const obj = {
    children: value,
    props: {},
  };
  return obj;
};

const _ActivityList = function ActivityList(props) {
  const abc = useRef(null);
  const [selectionType, setSelectionType] = useState(null);
  const [disable, setDisable] = useState(true);
  const ref = React.useRef();
  // const pinref = React.createRef()
  // const cmsRef = React.createRef()
  const listRef = props.listRef;

  listRef.current &&
    (listRef.current.show = (planCode) => {
      if (disable) {
        setDisable(false);
      }
      setSelectionType(planCode);
      showDialog(null, planCode);
    });

  const showDetail = (planCode) => {
    abc.current.show(planCode);
  };
  const columns = [
    {
      title: '',
      width: 20,
      dataIndex: 'planCode',
      render: (value) => {
        return (
          <Radio
            value={value}
            checked={value === selectionType}
            onChange={() => {
              if (disable) {
                setDisable(false);
              }
              setSelectionType(value);
            }}
          />
        );
      },
      align: 'center',
    },
    {
      title: '序号',
      width: 50,
      dataIndex: 'key',
      render: renderContent,
      align: 'center',
    },
    {
      title: '活动ID',
      width: 150,
      dataIndex: 'planCode',
      render: renderContent,
      align: 'center',
    },
    {
      align: 'center',
      title: '活动名称',
      width: 150,
      dataIndex: 'activityName',
      render: renderContent,
    },
    {
      title: '活动评级',
      width: 150,
      // dataIndex: 'level',
      render(dataItem) {
        return dataItem.otherLevel || ACTIVITY_LEVELS_MAP[dataItem.level];
      },
      align: 'center',
    },
    {
      align: 'center',
      title: '活动状态',
      width: 150,
      dataIndex: 'status',
      render(status) {
        return ACTIVITY_STATUS_MAP[status];
      },
    },
    {
      align: 'center',
      title: '操作',
      width: 70,
      dataIndex: 'address',
      render: (text, row, index) => {
        return <a onClick={() => showDetail(row.planCode)}>{text}</a>;
      },
    },
  ];
  const showDialog = async (_, s) => {

    if (!selectionType && !s) {
      return;
    }
    const dialogParam = {};
    dialogParam.planCode = s || selectionType;
    dialogParam.resourceId = props.resourceId;
    dialogParam.resourceName = props.resourceName;
    dialogParam.startTime = props.startTime;
    dialogParam.resourceFirstType = props.resourceFirstType;

    if (props.resourceFirstType === '0') {
      const option = {};
      option.planCode = s || selectionType;
      const result = await apis.fetchGetActivityDetail(option);
      if (result.ret === '0') {
        dialogParam.pin = result.data.activityPlan.pin;
        dialogParam.monetizedLevel = result.data.activityPlan.monetizedLevel;
        ref.current.checkDialog(dialogParam);
      } else {
        message.error(result.msg);
      }
    } else {
      ref.current.checkDialog(dialogParam);
    }

    // if (props.resourceFirstType === '1') {
    //   cmsRef.current.showModal(option.planCode, props.resourceId, props.resourceName, props.startTime)
    // } else if (props.resourceFirstType === '0') {
    //   const result = await apis.fetchGetActivityDetail(option)
    //   // 失败的提示
    //   if (result.ret === '0') {
    //     if (!result.data.activityPlan.pin || !result.data.activityPlan.monetizedLevel) {
    //       ref.current.showModal(option.planCode, props.resourceId, result.data.activityPlan.pin, result.data.activityPlan.monetizedLevel)
    //     } else {
    //       pinref.current.showModal(option.planCode, result.data.activityPlan.pin, props.resourceId, props.resourceName, props.startTime, result.data.activityPlan.monetizedLevel)
    //     }
    //   } else {
    //     message.error(result.msg)
    //   }
    // }
  };
  const onSuccess = () => {
    props.history.push('/playground/resources');
  };
  const close = async () => {
    props.history.go(-1);
  };
  return (
    <div>
      <div>
        <Table
          loading={props.loading}
          columns={columns}
          dataSource={props.data}
          tableLayout="fixed"
          pagination={{
            showSizeChanger: false,
            current: props.currentPage,
            total: props.totalCount,
            pageSize: 10,
            onChange: function (toPage) {
              props.onGetlist(toPage);
              // setSelectionType(null)
              // if (!disable) {
              //   setDisable(true)
              // }
            },
          }}
        />
        <SlidInActivityDetail ref={abc} />
      </div>
      <div className="resource-bottom">
        <Button onClick={close} style={{ marginRight: '10px' }}>
          返回
        </Button>
        <Button onClick={showDialog} type="primary" disabled={disable}>
          下一步
        </Button>
      </div>
      {/* <Dialog ref={ref} onSuccess={onSuccess} onFailed={() => {}} />
      <DialogPin ref={pinref} onSuccess={onSuccess} onFailed={() => {}} />
      <DialogCms ref={cmsRef} onSuccess={onSuccess} onFailed={() => {}} /> */}
      <DialogCheck ref={ref} onSuccess={onSuccess} onFailed={() => {}} />
    </div>
  );
};

export default withRouter(_ActivityList);
